import { render, staticRenderFns } from "./Sign.vue?vue&type=template&id=0f850fd9&scoped=true"
import script from "./Sign.vue?vue&type=script&lang=js"
export * from "./Sign.vue?vue&type=script&lang=js"
import style0 from "./Sign.vue?vue&type=style&index=0&id=0f850fd9&prod&scoped=true&lang=css"
import style1 from "./Sign.vue?vue&type=style&index=1&id=0f850fd9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f850fd9",
  null
  
)

export default component.exports